import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
} from "reactstrap";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { toast } from "react-toastify";
import axios from "axios";

const Valet = () => {
    const [valets, setValets] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [bosses, setBosses] = useState([]);
    const [editingValet, setEditingValet] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [error, setError] = useState("");
    const [photoFile, setPhotoFile] = useState(null);
    const [isBoss, setIsBoss] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState("");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets`)
            .then((response) => setValets(response.data))
            .catch((error) => toast.error("Error cargando valets:", error));

        axios.get(`${process.env.REACT_APP_PUBLIC_SERVER}/api/companies`)
            .then((response) => setCompanies(response.data))
            .catch((error) => toast.error("Error cargando empresas:", error));
    }, []);

    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 10 * 1024 * 1024) {
                alert("La imagen es demasiado grande. El tamaño máximo es 10 MB.");
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => setPhotoFile(reader.result.split(',')[1]);
            reader.readAsDataURL(file);
        }
    };

    const addValet = (newValet) => {
        axios.post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets`, newValet)
            .then((response) => {
                setValets([...valets, response.data]);
                setBosses([...bosses, ...(response.data.is_boss ? [response.data] : [])]);
                setShowForm(false);
                setError("");
                toast.success("Valet agregado con éxito");
            })
            .catch((error) => {
                toast.error("Error agregando valet:", error);
                setError(error.response?.data?.message || "Error al agregar el valet.");
            });
    };

    const updateValet = (updatedValet) => {
        axios.put(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets/${updatedValet.id}`, updatedValet)
            .then((response) => {
                setValets(valets.map((valet) => (valet.id === updatedValet.id ? response.data : valet)));
                setBosses(valets.filter(valet => valet.is_boss));
                setShowForm(false);
                setError("");
                toast.success("Valet actualizado con éxito");
            })
            .catch((error) => {
                toast.error("Error actualizando valet:", error);
                setError(error.response?.data?.message || "Error al actualizar el valet.");
            });
    };

    const deleteValet = (id) => {
        if (window.confirm("¿Estás seguro de que deseas eliminar este valet?")) {
            axios.delete(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets/${id}`)
                .then(() => {
                    setValets(valets.filter((valet) => valet.id !== id));
                    setBosses(bosses.filter(boss => boss.id !== id));
                    toast.success("Valet eliminado con éxito");
                })
                .catch((error) => toast.error("Error eliminando valet:", error));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const valetData = {
            full_name: formData.get("full_name"),
            email: formData.get("email"),
            phone_number: formData.get("phone_number"),
            personal_identification: formData.get("personal_identification"),
            photo: photoFile || (editingValet ? editingValet.photo : null),
            companyIds: [formData.get("company_id")],  // Enviar como arreglo
            password: formData.get("password"),
            is_boss: isBoss,
            boss_id: isBoss ? null : formData.get("boss_id") || null,
        };

        if (editingValet) {
            valetData.id = editingValet.id;
            updateValet(valetData);
        } else {
            addValet(valetData);
        }
    };

    const handleCompanyChange = (e) => {
        const companyId = e.target.value;
        setSelectedCompany(companyId);
        setBosses(valets.filter(valet => valet.is_boss && valet.company_id === companyId));
    };

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Valets" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12" className="text-right">
                        <Button color="success" onClick={() => {
                            setEditingValet(null);
                            setShowForm(true);
                            setError("");
                            setIsBoss(false);
                        }}>
                            Agregar Valet
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader><h5>Valets</h5></CardHeader>
                            <CardBody>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th style={{ color: "black" }}>Foto</th>
                                            <th style={{ color: "black" }}>Nombre</th>
                                            <th style={{ color: "black" }}>Correo</th>
                                            <th style={{ color: "black" }}>Teléfono</th>
                                            <th style={{ color: "black" }}>ID Personal</th>
                                            <th style={{ color: "black" }}>Empresa</th>
                                            <th style={{ color: "black" }}>¿Jefe?</th>
                                            <th style={{ color: "black" }}>Jefe Asignado</th>
                                            <th style={{ color: "black" }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {valets.map((valet) => (
                                            <tr key={valet.id}>
                                                <td>{valet.photo ? <img src={`data:image/jpeg;base64,${valet.photo}`} alt="Foto" width="50" /> : "Sin foto"}</td>
                                                <td style={{ color: "black" }}>{valet.full_name}</td>
                                                <td style={{ color: "black" }}>{valet.email}</td>
                                                <td style={{ color: "black" }}>{valet.phone_number}</td>
                                                <td style={{ color: "black" }}>{valet.personal_identification}</td>
                                                <td style={{ color: "black" }}>{valet.company_name}</td>
                                                <td style={{ color: "black" }}>{valet.is_boss ? "Sí" : "No"}</td>
                                                <td style={{ color: "black" }}>{valet.boss_id ? valets.find(b => b.id === valet.boss_id)?.full_name : "-"}</td>
                                                <td>
                                                    <Button color="primary" onClick={() => {
                                                        setEditingValet(valet);
                                                        setShowForm(true);
                                                        setError("");
                                                        setIsBoss(valet.is_boss);
                                                        setSelectedCompany(valet.company_id);
                                                    }} className="mr-2">
                                                        Editar
                                                    </Button>
                                                    <Button color="danger" onClick={() => deleteValet(valet.id)}>
                                                        Eliminar
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {showForm && (
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardHeader><h5>{editingValet ? "Editar Valet" : "Agregar Valet"}</h5></CardHeader>
                                <CardBody>
                                    {error && <div className="alert alert-danger">{error}</div>}
                                    <Form onSubmit={handleSubmit} key={editingValet ? editingValet.id : "new"}>
                                        <FormGroup>
                                            <Label for="photo">Foto del Valet</Label>
                                            <Input type="file" name="photo" id="photo" onChange={handlePhotoChange} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="full_name">Nombre Completo</Label>
                                            <Input type="text" name="full_name" id="full_name" defaultValue={editingValet ? editingValet.full_name : ""} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="email">Correo Electrónico</Label>
                                            <Input type="email" name="email" id="email" defaultValue={editingValet ? editingValet.email : ""} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="password">Contraseña</Label>
                                            <Input type="password" name="password" id="password" required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="phone_number">Teléfono</Label>
                                            <Input type="tel" name="phone_number" id="phone_number" defaultValue={editingValet ? editingValet.phone_number : ""} pattern="[0-9]*" required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="personal_identification">Identificación Personal</Label>
                                            <Input type="text" name="personal_identification" id="personal_identification" defaultValue={editingValet ? editingValet.personal_identification : ""} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="company_id">Empresa</Label>
                                            <Input type="select" name="company_id" id="company_id" value={selectedCompany} onChange={handleCompanyChange} required>
                                                <option value="">Selecciona una empresa</option>
                                                {companies.map(company => (
                                                    <option key={company.id} value={company.id}>{company.legal_name}</option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                        <FormGroup className="checkbox-group">
                                            <Label for="is_boss">¿Es Jefe?</Label>
                                            <Input type="checkbox" name="is_boss" id="is_boss" checked={isBoss} onChange={(e) => setIsBoss(e.target.checked)} />
                                        </FormGroup>
                                        {!isBoss && (
                                            <FormGroup>
                                                <Label for="boss_id">Jefe Asignado</Label>
                                                <Input type="select" name="boss_id" id="boss_id" defaultValue={editingValet ? editingValet.boss_id : ""}>
                                                    <option value="">Selecciona un jefe</option>
                                                    {bosses.map(boss => (
                                                        <option key={boss.id} value={boss.id}>{boss.full_name}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        )}
                                        <Button type="submit" color="success" className="mr-2">Guardar</Button>
                                        <Button type="button" color="secondary" onClick={() => setShowForm(false)} className="mr-2">Cancelar</Button>
                                        <Button type="reset" color="secondary">Limpiar</Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Container>
        </Fragment>
    );
};

export default Valet;